import axios from 'axios';
import { mesazhiIGabimit } from '@/utils/error-message';
import store from '@/store';

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import Router from '../router/index';

const loginEvent = 'freshToken';
const userRoleEvent = 'userRole';
const simpleModeEvent = 'simple_mode';

export default {
  async login2(payload) {
    await authClient.get('/sanctum/csrf-cookie');
    return authClient.post('/login', payload);
  },
  isUserLoggedIn() {
    let isAuthenticated = false;

    // get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser;

    if (firebaseCurrentUser) isAuthenticated = true;
    else isAuthenticated = false;

    // return localStorage.getItem(loginEvent) != "null";
    return (
      localStorage.getItem(loginEvent) != null &&
      localStorage.getItem(loginEvent) != 'null'
    );
  },
  getLoggedInUserRole() {
    const userRole = localStorage.getItem(userRoleEvent);
    if (userRole == 1) return 'admin';
    else if (userRole == 2) return 'school';
    else if (userRole == 3) return 'driver';
    else if (userRole == 4 || userRole == 5) return 'parent';
    else if (userRole == 6) return 'student';
    else if (userRole == 7) return 'director';
    else return null;
  },
  getMode() {
    const simple_mode = localStorage.getItem(simpleModeEvent);
    if (simple_mode == 1) return 'simple';
    else return 'advanced';
  },

  /**
   * Hyrje ne versionin demo — pa Firebase dhe pa fjalekalim.
   * Serveri e di vete cila llogari i pergjigjet pamjes se kerkuar.
   */
  async demoLogin(view) {
    const response = await axios.post(`/auth/demo-login/${view}`, {
      device_name: 'demo-web',
      // Shfletuesi qe e ka verifikuar email-in dikur nuk pyetet me.
      device_token: localStorage.getItem('demo_device_token') || undefined,
    });

    const user = response.data.user_data;
    const freshToken = response.data.token.split('|')[1];

    localStorage.setItem(loginEvent, freshToken);
    localStorage.setItem(userRoleEvent, user.role_id);
    localStorage.setItem(simpleModeEvent, response.data.simple_mode);
    localStorage.setItem('demo_mode', '1');
    localStorage.setItem('demo_notice_pending', '1');
    // Gjendja e verifikimit vjen nga serveri ne cdo hyrje te re.
    localStorage.removeItem('demo_identified');
    axios.defaults.headers.common[`Authorization`] = `Bearer ${freshToken}`;

    return user;
  },

  async login(payload) {
    // If user is already logged in, redirect to their dashboard
    if (this.isUserLoggedIn()) {
      const role = this.getLoggedInUserRole();
      if (role === 'admin') Router.push('/admin-dashboard').catch(() => {});
      else if (role === 'school' || role === 'director')
        Router.push('/school-dashboard').catch(() => {});
      else if (role === 'parent') Router.push('/parent-dashboard').catch(() => {});
      else if (role === 'student') Router.push('/student/dashboard').catch(() => {});
      else if (role === 'driver') Router.push('/driver/dashboard').catch(() => {});
      else Router.push('/login').catch(() => {});
      return false;
    }
    // Try to sigin
    try {
      var result = await firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password);
      var token = await result.user.getIdToken(true);
      var response = await axios.post('/auth/loginViaToken', {
        device_name: `${vm.$browserDetect.meta.name}- v${vm.$browserDetect.meta.version}`,
        token,
      });
      let user = response.data.user_data;
      const userRole = user.role_id;
      // if (userRole != 1 && userRole != 2 && userRole != 4) {
      //   const error = Error(
      //     'Your account can not be used here! Only admin accounts.'
      //   );
      //   error.name = 'Not admin';
      //   throw error;
      // }
      const ourToken = response.data.token;
      const freshToken = ourToken.split('|')[1];
      const simple_mode = response.data.simple_mode;
      localStorage.setItem(loginEvent, freshToken);
      localStorage.setItem(userRoleEvent, userRole);
      localStorage.setItem(simpleModeEvent, simple_mode);
      // Nje hyrje reale i mbyll gjurmet e demos. Pa kete, aplikacioni do ta
      // trajtonte perdoruesin ende si vizitor demo dhe rojtari do t'ia
      // shkeputte sesionin ne vizite e ardhshme te /login.
      localStorage.removeItem('demo_mode');
      localStorage.removeItem('demo_notice_pending');
      localStorage.removeItem('demo_identified');
      axios.defaults.headers.common['Authorization'] = `Bearer ${freshToken}`;
      return user;
    } catch (error) {
      localStorage.setItem(loginEvent, null);
      localStorage.setItem(userRoleEvent, null);
      localStorage.setItem(simpleModeEvent, null);
      payload.notify({
        text: mesazhiIGabimit(error),
        type: 'error',
      });
      return null;
    }
  },

  async getEmailForTelNumber(payload) {
    try {
      var response = await axios.post(
        '/auth/login-get-email-for-tel-number',
        payload
      );
      return response?.data?.email;
    } catch (error) {
      console.log(error?.response);
      payload.notify({
        text: error?.response?.data?.errors?.authentication ?? error?.message,
        type: 'error',
      });
      return null;
    }
  },

  async register(payload) {
    // If user is already logged in notify and exit
    if (this.isUserLoggedIn()) {
      payload.notify({
        title: 'Sign up Attempt',
        text: 'You are already logged in!',
        type: 'warning',
      });
      Router.push('/login').catch(() => {});
      return false;
    }
    // Try to register
    try {
      var result = await firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password);
      var token = await result.user.getIdToken(true);
      var response = await axios.post('/auth/sign-up-via-token', {
        device_name: `${vm.$browserDetect.meta.name}- v${vm.$browserDetect.meta.version}`,
        token,
        role: 2,
        name: payload.name,
        email: payload.email,
        'g-recaptcha-response': payload.recaptcha,
      });
      let user = response.data.user_data;
      const userRole = user.role_id;
      if (userRole != 1 && userRole != 2) {
        const error = Error(
          'Your account can not be used here! Only admin accounts.'
        );
        error.name = 'Not admin';
        throw error;
      }
      const ourToken = response.data.token;
      const freshToken = ourToken.split('|')[1];
      const simple_mode = response.data.simple_mode;
      localStorage.setItem(loginEvent, freshToken);
      localStorage.setItem(userRoleEvent, userRole);
      localStorage.setItem(simpleModeEvent, simple_mode);
      // Nje hyrje reale i mbyll gjurmet e demos. Pa kete, aplikacioni do ta
      // trajtonte perdoruesin ende si vizitor demo dhe rojtari do t'ia
      // shkeputte sesionin ne vizite e ardhshme te /login.
      localStorage.removeItem('demo_mode');
      localStorage.removeItem('demo_notice_pending');
      localStorage.removeItem('demo_identified');
      axios.defaults.headers.common['Authorization'] = `Bearer ${freshToken}`;
      return user;
    } catch (error) {
      localStorage.setItem(loginEvent, null);
      localStorage.setItem(userRoleEvent, null);
      localStorage.setItem(simpleModeEvent, null);
      payload.notify({
        text: mesazhiIGabimit(error),
        type: 'error',
      });
      return null;
    }
  },

  async logout() {
    // if user is logged in via firebase
    const firebaseCurrentUser = firebase.auth().currentUser;

    if (firebaseCurrentUser) {
      await firebase.auth().signOut();
    }

    localStorage.setItem(loginEvent, null);
    localStorage.setItem(userRoleEvent, null);
    localStorage.setItem(simpleModeEvent, null);

    // If user clicks on logout -> redirect
    Router.push('/login').catch(() => {});
  },
  logout2() {
    return authClient.post('/logout');
  },
  async forgotPassword(payload) {
    await authClient.get('/sanctum/csrf-cookie');
    return authClient.post('/forgot-password', payload);
  },
  getAuthUser() {
    return authClient.get('/api/users/auth');
  },
  async resetPassword(payload) {
    return axios.post('/auth/reset-password', {
      email: payload.email,
    });
  },
  updatePassword(payload) {
    return authClient.put('/user/password', payload);
  },
  async registerUser(payload) {
    await authClient.get('/sanctum/csrf-cookie');
    return authClient.post('/register', payload);
  },
  sendVerification(payload) {
    return authClient.post('/email/verification-notification', payload);
  },
  updateUser(payload) {
    return authClient.put('/user/profile-information', payload);
  },

  checkError(error, router, swal) {
    if (error.includes('Unauthenticated')) {
      this.logout();
      router.push({ name: 'login' });
    } else {
      swal('Error', error, 'error');
    }
  },
};
